import { voucherApi } from "@/shared/core-vouchers";
import { trackEvent } from "@/utils/firebase/analytics";

export const downloadVouchersExcel = async (params: string) => {
  const report = await voucherApi.exportVouchersExcel(params);
  const reportURL = URL.createObjectURL(report);
  const link = document.createElement("a");
  link.href = reportURL;
  link.download = "vouchers.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(reportURL);

  trackEvent("export", {
    type: "xlsx",
    module: "vouchers",
  });
};
